import axiosInstance from '../utils/axiosConfig';

const BASE_URL = '/api/budget';

export const budgetService = {
  // Headers
  listHeaders: async (params = {}) => {
    const response = await axiosInstance.get(`${BASE_URL}/headers/`, { params });
    return response.data;
  },

  getHeader: async (id) => {
    const response = await axiosInstance.get(`${BASE_URL}/headers/${id}/`);
    return response.data;
  },

  createHeader: async (data) => {
    const response = await axiosInstance.post(`${BASE_URL}/headers/`, data);
    return response.data;
  },

  updateHeader: async (id, data) => {
    const response = await axiosInstance.patch(`${BASE_URL}/headers/${id}/`, data);
    return response.data;
  },

  deleteHeader: async (id) => {
    const response = await axiosInstance.delete(`${BASE_URL}/headers/${id}/`);
    return response.data;
  },

  // Lines
  getLines: async (headerId) => {
    const response = await axiosInstance.get(`${BASE_URL}/headers/${headerId}/lines/`);
    return response.data;
  },

  // Actions
  seedLines: async (headerId) => {
    const response = await axiosInstance.post(`${BASE_URL}/headers/${headerId}/seed/`);
    return response.data;
  },

  calculate: async (headerId) => {
    const response = await axiosInstance.post(`${BASE_URL}/headers/${headerId}/calculate/`);
    return response.data;
  },

  pullFromEnquiry: async (headerId) => {
    const response = await axiosInstance.get(`${BASE_URL}/headers/${headerId}/pull-from-enquiry/`);
    return response.data;
  },

  // Classifications
  listClassifications: async () => {
    const response = await axiosInstance.get(`${BASE_URL}/classifications/`);
    return response.data;
  },

  // Units
  getUnits: async () => {
    const response = await axiosInstance.get(`${BASE_URL}/units/`);
    return response.data;
  },
};
